import { SortingOptions } from 'types';
import { ServerModels as SM } from 'types/server';
import { sortingDirectionMap } from './sortingDirectionMap';

export const toServerSorting = (value: SortingOptions): SM.SortingField | null => {
  if (!value) return null;
  return { field: value.field, direction: sortingDirectionMap[value.direction] };
};
